import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetRetuneScriptsRequest = (siteList) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetRetuneScripts`,
	params: { siteList }
});

export const GetDss2100ScriptsRequest = (siteList) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetDss2100Scripts`,
	params: { siteList }
});

export const GetDss2100EricssonScriptsRequest = (filePath, siteList) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Scripts/GetDss2100EricssonScripts`,
	params: { filePath, siteList }
});
